<template>
  <div>
    <div align="left"></div>
    <br />
    <div class="text-left">
      <h5 class="font-weight-bold text-primary">Benefit</h5>
      <b-row>
        <b-col md="12">
          <b-row class="mt-4">
            <b-col md="2" class="my-1">
              <b-input-group>
                <b-input-group-text
                  class="bg-white border-right-0"
                  slot="prepend"
                >
                  <img src="@/assets/filter.svg" alt />
                </b-input-group-text>
                <b-dropdown
                  text="Filter Data"
                  variant="light"
                  toggle-class="bg-white border-secondary text-primary border-left-0 pl-0"
                  slot="append"
                >
                  <div class="p-3">
                    <b-row>
                      <b-col md="6">
                        <b-form-group
                          id="fieldset-1"
                          label="Title"
                          class="font-weight-bold"
                          label-for="input-1"
                        >
                          <input
                            placeholder="Title"
                            v-model="title"
                            name="title"
                            type="text"
                            data-vv-as="Title"
                            class="form-control"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                  <b-col md="6">
                    <b-form-group
                      id="fieldset-1"
                      label="Pic Name"
                      class="font-weight-bold"
                      label-for="input-1"
                    >
                      <input
                        placeholder="Pic Name"
                        v-model="search_pic_name"
                        name="pic_name"
                        type="text"
                        data-vv-as="Pic Name"
                        class="form-control"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                      <b-form-group
                        id="fieldset-1"
                        label="Pic Contact"
                        class="font-weight-bold"
                        label-for="input-1"
                      >
                        <input
                          placeholder="Pic Contact"
                          v-model="pic_contact"
                          name="pic_contact"
                          type="text"
                          data-vv-as="Pic Contact"
                          class="form-control"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                    <b-row>
                      <b-col md="6">
                        <b-form-group
                          id="fieldset-1"
                          label="Member Type"
                          class="font-weight-bold"
                          label-for="input-1"
                        >
                          <b-form-select
                            v-model="membership_type"
                            name="membership_type"
                            data-vv-as="Member Type"
                            class="mb-3"
                          >
                            <template v-slot:first>
                              <option value disabled>-- Member Type --</option>
                            </template>
                            <option value="gold">Gold</option>
                            <option value="silver">Silver</option>
                            <option value="gold2.0">Gold2.0</option>
                            <option value="silver2.0">Silver2.0</option>
                          </b-form-select>
                        </b-form-group>
                      </b-col>
                      <b-col md="6">
                        <b-form-group
                          id="fieldset-1"
                          label="Benefit Type"
                          class="font-weight-bold"
                          label-for="input-1"
                        >
                          <b-form-select
                            v-model="benefit_type_id"
                            name="benefit_type_id"
                            data-vv-as="Benefit Type"
                            class="mb-3"
                          >
                            <template v-slot:first>
                              <option value disabled>-- Benefit Type --</option>
                            </template>
                            <option
                              v-for="type_item in type_list"
                              :key="type_item.id"
                              :value="type_item.id"
                            >
                              {{ type_item.display }}
                            </option>
                          </b-form-select>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="12">
                        <b-form-group
                          id="fieldset-1"
                          label="Created Date Period"
                          class="font-weight-bold"
                          label-for="input-1"
                        >
                          <b-row>
                            <b-col>
                              <b-row class="m-0">
                                <b-col
                                  class="
                                    pr-0
                                    form-control form-control-sm
                                    img-calender-select
                                    border-right-0
                                  "
                                  md="4"
                                >
                                  <img
                                    src="@/assets/ic-calendar-copy-30.svg"
                                    width="20px"
                                    alt
                                    class="mt-n1"
                                  />
                                </b-col>
                                <b-col md="6" class="px-0">
                                  <datepicker
                                    input-class="form-control form-control-sm text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                                    placeholder="Select Date"
                                    v-model="created_at_start"
                                    :format="customFormatter"
                                    :disabledDates="disabledCreatedDatesStart"
                                  ></datepicker>
                                </b-col>
                                <b-col align="left" md="1" class="px-0">
                                  <b-col
                                    align="left"
                                    class="
                                      px-4
                                      form-control form-control-sm
                                      del-calender-select
                                      border-left-0
                                    "
                                    md="2"
                                  >
                                    <b-row align="left">
                                      <b-col>
                                        <b-button
                                          class="
                                            m-0
                                            p-0
                                            mt-n1
                                            bg-transparent
                                            border-0
                                          "
                                          @click="resetDateCreatedStart"
                                          variant="outline-light"
                                        >
                                          <i class="text-danger fas fa-times"></i>
                                        </b-button>
                                      </b-col>
                                    </b-row>
                                  </b-col>
                                </b-col>
                              </b-row>
                            </b-col>
                            <b-col>
                              <b-row class="m-0">
                                <b-col
                                  class="
                                    pr-0
                                    form-control form-control-sm
                                    img-calender-select
                                    border-right-0
                                  "
                                  md="4"
                                >
                                  <img
                                    src="@/assets/ic-calendar-copy-30.svg"
                                    width="20px"
                                    alt
                                    class="mt-n1"
                                  />
                                </b-col>
                                <b-col md="6" class="px-0">
                                  <datepicker
                                    input-class="form-control form-control-sm text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                                    placeholder="Select Date"
                                    v-model="created_at_end"
                                    :format="customFormatter"
                                    :disabledDates="disabledCreatedDatesEnd"
                                  ></datepicker>
                                </b-col>
                                <b-col align="left" md="1" class="px-0">
                                  <b-col
                                    align="left"
                                    class="
                                      px-4
                                      form-control form-control-sm
                                      del-calender-select
                                      border-left-0
                                    "
                                    md="2"
                                  >
                                    <b-row align="left">
                                      <b-col>
                                        <b-button
                                          class="
                                            m-0
                                            p-0
                                            mt-n1
                                            bg-transparent
                                            border-0
                                          "
                                          @click="resetDateCreatedEnd"
                                          variant="outline-light"
                                        >
                                          <i class="text-danger fas fa-times"></i>
                                        </b-button>
                                      </b-col>
                                    </b-row>
                                  </b-col>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <br />
                    <b-row style="text-align-last: right">
                      <b-col>
                        <b-button
                          variant="outline-secondary"
                          @click="resetSearch()"
                          class="mr-3"
                          >Set Ulang</b-button
                        >
                        <b-button variant="primary" @click="search()"
                          >Cari</b-button
                        >
                      </b-col>
                    </b-row>
                  </div>
                  <b-dropdown-item
                    class="pointer-off"
                    style="width: 450px"
                  ></b-dropdown-item>
                </b-dropdown>
              </b-input-group>
            </b-col>
            <b-col md="2" class="my-1" align="right">
              <b-form inline>
                Show &nbsp;
                <b-form-select
                  v-model="perPage"
                  :options="pageOptions"
                ></b-form-select>
                &nbsp; Records
              </b-form>
            </b-col>
            <b-col md="5" class="my-1"></b-col>
            <b-col md="3" class="my-1" align="right">
              <!-- <b-button class="btn btn-warning px-4" style="padding-top:6px;padding-bottom:6px" :disabled="loadingCSV" @click="downloadCSV()">
                  <b-spinner label="Spinning" v-show="loadingCSV"></b-spinner> <i class="fas fa-file-download" style="font-size:16px"></i> &nbsp; Export to CSV
                </b-button> -->
              <router-link :to="{ name: 'createBenefit' }">
                <b-button variant="primary">
                  <img src="@/assets/create-new.svg" class="mr-2" alt />Create
                  New
                </b-button>
              </router-link>
            </b-col>
          </b-row>
          <b-row>
            <br />
          </b-row>
          <section v-if="errored">
            <p>
              We're sorry, we're not able to retrieve this information at the
              moment, please try back later
            </p>
          </section>
          <!-- Main table element -->
          <b-table
            v-else
            show-empty
            hover
            ref="selectableTable"
            selectable
            :select-mode="selectMode"
            @row-selected="onRowSelected"
            responsive="sm"
            stacked="md"
            :busy="loading"
            :items="getInfo"
            :fields="key"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            @filtered="onFiltered"
            head-variant="light"
            class="bg-white"
          >
            <div slot="table-busy" class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
            <template v-slot:head(selected)="data">
              <span class="text-info">
                <b-form-checkbox
                  v-model="allSelected"
                  :indeterminate="indeterminate"
                  aria-describedby="items"
                  aria-controls="items"
                  @change="toggleAll"
                ></b-form-checkbox>
              </span>
            </template>
            <template v-slot:cell(selected)="{ rowSelected, item, index }">
              <template v-if="rowSelected">
                <span aria-hidden="true">
                  <b-form-checkbox
                    id="checkbox-1"
                    v-model="selected_field_true"
                    name="checkbox-1"
                    value="true"
                    class="pointer-off"
                    unchecked-value="false"
                  ></b-form-checkbox>
                </span>
                <span class="sr-only">Selected</span>
              </template>
              <template v-else>
                <span aria-hidden="true">
                  <b-form-checkbox
                    id="checkbox-1"
                    v-model="selected_field_false"
                    name="checkbox-1"
                    value="true"
                    class="pointer-off"
                    unchecked-value="false"
                  ></b-form-checkbox>
                </span>
                <span class="sr-only">Not selected</span>
              </template>
            </template>
            <template v-slot:cell(created_at_date_only)="{ value, item }">
              <p class="mb-0">{{ item.created_at_date_only }}</p>
              by {{ item.created_by_username }}
            </template>
            <template v-slot:cell(updated_at_date_only)="{ value, item }">
              <div v-if="item.updated_at_date_only == ''">-</div>
              <div v-else>
                <p class="mb-0">{{ item.updated_at_date_only }}</p>
                by {{ item.updated_by_username }}
              </div>
            </template>
            <template v-slot:cell(status)="row">
              <p class="text-success" v-if="row.value == 'publish'">Publish</p>
              <p class="text-warning" v-else-if="row.value == 'archive'">
                Archive
              </p>
            </template>
            <template v-slot:cell(image_url)="row">
              <b-img :src="row.value" width="70px" rounded alt="Image"></b-img>
            </template>
            <template v-slot:cell(benefit_category)="row">
              <label>{{ row.value.display }}</label>
            </template>
            <template v-slot:cell(benefit_type)="row">
              <label>{{ row.value.display }}</label>
            </template>
            <template v-slot:cell(membership_types)="row">
              <label v-if="row.value.length > 1 && isGoldAndSilver(row.value)">Gold & Silver</label>
              <label v-else-if="row.value.length > 1 && isGold20AndSilver20(row.value)">Gold2.0 & Silver2.0</label>
              <label class="text-capitalize" v-else>{{ row.value.length == 1 ? row.value[0] : '-' }}</label>
            </template>
            <template v-slot:cell(titles.id)="row">
              <label class="text-primary font-weight-bold">{{
                row.value
              }}</label>
            </template>
            <template v-slot:cell(action)="{ value, item }">
              <b-row>
                <router-link
                  v-b-tooltip.hover
                  title="Edit"
                  :to="{name: 'editBenefit', params: {benefit_code: item.benefit_code}}"
                  class="text-dark"
                >
                  <img src="@/assets/ic-edit.svg" class="mr-2" alt />
                </router-link>
                <b-link v-b-tooltip.hover title="Delete" class="text-dark" @click="del(item.id)">
                  <img src="@/assets/rectangle.svg" class="mr-2" alt />
                </b-link>
                <b-col>
                  <b-form-checkbox
                    switch
                    v-model="item.enable"
                    @change="activation(item)"
                  ></b-form-checkbox>
                </b-col>
              </b-row>
            </template>
          </b-table>

          <b-row class="mx-auto">
            <b-col md="4" class="mx-auto px-0">
              <div v-if="totalRows == 0 || totalRows == null">
                Showing 0 Records
              </div>
              <div v-else>
                Showing {{ fromPage[currentPage - 1] }} to
                {{ toPage[currentPage - 1] }} of {{ totalRows }} Records
              </div>
            </b-col>
            <b-col md="4" class="mx-auto"></b-col>
            <b-col md="4" align="right" class="px-0">
              <b-pagination
                align="right"
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              ></b-pagination>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    Datepicker,
  },
  data() {
    return {
      loading: false,
      errored: false,
      membership_type: "",
      items: [],
      vuex: [],
      selected: [],
      key: [
        {
          key: "selected",
          class: "text-center",
        },
        {
          key: "benefit_code",
          label: "Benefit Code",
          sortable: true,
          class: "text-center",
        },
        {
          key: "membership_types",
          label: "Membership Type",
          sortable: true,
          class: "text-center",
        },
        {
          key: "benefit_category",
          label: "Category",
          sortable: true,
          class: "text-center",
        },
        {
          key: "benefit_type",
          label: "Type",
          sortable: true,
          class: "text-center",
        },
        {
          key: "titles.id",
          label: "Title",
          sortable: true,
          class: "text-left",
        },
        {
          key: "image_url",
          label: "Image",
          sortable: true,
          class: "text-left",
        },
        { key: "action", label: "", class: "text-center w-10" },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      type_list: [],
      filter: null,
      title: "",
      search_pic_name: "",
      pic_contact: "",
      fromPage: "",
      toPage: "",
      benefit_type_id: "",
      created_at_start: "",
      created_at_end: "",
      valid_until_start: "",
      valid_until_end: "",
      selectMode: "multi",
      customerShow: false,
      selected_field_true: true,
      selected_field_false: false,
      allSelected: false,
      indeterminate: false,
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
    filterPOSM() {
      return this.day_preferenceList.filter((day_pick) => day_pick.is_selected);
    },
    disabledCreatedDatesStart() {
      var disabledDates = {
        from: new Date(this.created_at_end + 8640000),
      };
      return disabledDates;
    },
    disabledCreatedDatesEnd() {
      var disabledDates = {
        to: new Date(this.created_at_start - 8640000),
      };
      return disabledDates;
    },
  },
  beforeCreate() {
    const formData = new FormData();
    formData.append("search_param", "");
    formData.append("limit", "1000");
    formData.append("page", "1");
    formData.append("sort_by", "");
    formData.append("is_sort_asc", true);
    this.$store
      .dispatch("BenefitTypeModule/getBenefitTypes", formData)
      .then((response) => {
        this.type_list = response.data.data.type_benefits || [];
        this.loading = false;
      })
      .catch((error) => {
        this.$swal({
          type: "error",
          title: "Oops...",
          text: error.response.data.message,
          showConfirmButton: false,
          timer: 1500,
        });
        this.loading = false;
      });
  },
  methods: {
    isGoldAndSilver(membership) {
      if (typeof membership !== 'undefined') {
        return membership.includes("gold") && membership.includes("silver");
      }
      return false;
    },
    isGold20AndSilver20(membership) {
      if (typeof membership !== 'undefined') {
        return membership.includes("gold2.0") && membership.includes("silver2.0");
      }
      return false;
    },
    search() {
      this.$refs.selectableTable.refresh();
    },
    resetDateCreatedStart() {
      this.created_at_start = "";
    },
    resetDateCreatedEnd() {
      this.created_at_end = "";
    },
    resetDateValidStart() {
      this.valid_until_start = "";
    },
    resetDateValidEnd() {
      this.valid_until_end = "";
    },
    resetSearch() {
      this.$refs.selectableTable.refresh();
      this.membership_type = "";
      this.benefit_type_id = "";
      this.title = "";
      this.search_pic_name = "";
      this.pic_contact = "";
      this.created_at_start = "";
      this.created_at_end = "";
    },
    getInfo(ctx, callback) {
      this.loading = true;
      const vm = this;
      const formData = new FormData();
      formData.append("search_param", ctx.filter);
      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("sort_by", ctx.sortBy);
      formData.append("is_sort_asc", ctx.sortDesc);
      formData.append("title", this.title);
      formData.append("membership_type", this.membership_type);
      formData.append("benefit_type_id", this.benefit_type_id);
      formData.append("pic_name", this.search_pic_name);
      formData.append("pic_contact", this.pic_contact);
      formData.append(
        "created_at_start",
        this.created_at_start != ""
          ? moment(this.created_at_start).format(`YYYY-MM-DDT`) + "00:00"
          : ""
      );
      formData.append(
        "created_at_end",
        this.created_at_end != ""
          ? moment(this.created_at_end).format("YYYY-MM-DDT") + "23:59"
          : ""
      );
      this.$store
        .dispatch("BenefitModule/getBenefits", formData)
        .then((response) => {
          vm.totalRows = response.data.data.total_record;
          var from = [];
          var to = [];
          var sum = 0;
          for (let i = 1; i <= vm.currentPage; i++) {
            sum = i * vm.perPage;
            if (vm.totalRows <= sum) {
              from.push(sum - vm.perPage + 1);
              to.push(vm.totalRows - sum + sum);
            } else {
              from.push(sum - vm.perPage + 1);
              to.push(sum);
            }
          }
          this.fromPage = from;
          this.toPage = to;
          this.items = response.data.data.benefits || [];
          callback(response.data.data.benefits || []);
          this.loading = false;
        })
        .catch((error) => {
          this.$swal({
            type: "error",
            title: "Error!",
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.loading = false;
          callback([]);
        });
      return null;
    },
    onRowSelected(items) {
      this.selected = items;
    },
    toggleAll(checked) {
      this.selected = checked
        ? this.$refs.selectableTable.selectAllRows()
        : this.$refs.selectableTable.clearSelected();
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    del(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch("BenefitModule/deleteBenefit", id)
          .then((response) => {
            this.$refs.selectableTable.refresh();
            this.$swal("Deleted!", "Your data has been deleted.", "success");
          })
          .catch((error) => {
            this.$swal({
              type: "error",
              title: "Oops...",
              text: error.response.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
            console.log(error);
          });
        }
      });
    },
    activation(item) {
      this.$swal({
        title: "Are you sure?",
        text: "You will change status Benefit!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, change it!",
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          const formData = new FormData();
          formData.append("enable", item.enable);
          const payload = {
            id: item.id,
            data: formData,
          };
          this.$store
            .dispatch("BenefitModule/postActivation", payload)
            .then((response) => {
              console.log(response);
              this.loading = false;
              this.$refs.selectableTable.refresh();
            })
            .catch((error) => {
              this.loading = false;
              this.$refs.selectableTable.refresh();
              console.log(error);
            });
        } else {
          item.enable = !item.enable;
        }
      });
    },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
  },
  watch: {
    selected(newVal, oldVal) {
      if (newVal) {
        if (newVal.length === 0) {
          this.indeterminate = false;
          this.allSelected = false;
        } else if (newVal.length === this.items.length) {
          this.indeterminate = false;
          this.allSelected = true;
        } else {
          this.indeterminate = true;
          this.allSelected = false;
        }
      }
    },
  },
};
</script>

<style>
</style>
